
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TagsViewModule, ITagView } from '@/store/modules/tagsView'
import {IMenuItem} from "@/store/modules/menu";
@Component({
    name: 'SmarteduMenuItem',
})
export default class SmarteduMenuItem extends Vue {
    @Prop() private menu!: [];
    @Prop() private level!: 0;

    // 启用下面的代码，点击菜单时会保留当前页面。但是会刷新，之前填的内容都没有了
    private go(menu: IMenuItem){
      const views = this.$store.state.tagsView.visitedViews;
      const view = views.find((v:any) => v.key == menu.url);
      if(view && view.path !== menu.url){
        // 转到这个标签
        view.path = menu.url;
        return;
      } else {
        const route = this.$router.getRoutes().find(r => r.path === menu.url);
        const routeName = route !== undefined ? route.name : "";
        TagsViewModule.addView({
          title: menu.name,
          path: menu.url,
          key: menu.url,
          routeName: routeName!,
          module: menu.moduleId,
          active: true,
          history: []
        })
      }
    }
}
